
import PropTypes from 'prop-types'
import { createOnFilter } from 'filter'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import MuiFormSelect from 'frame/components/mui-form-select'

const FilterAttributes = ({ filters, filtered, onFilter }) => {
  const onSelect = createOnFilter(onFilter)
  const hasList = (list) => list.length > 0
  const { wofStatuses, registrationStatuses, agreementTypes, fmoTypes } = filters

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingY: 1,
          paddingX: 0,
          cursor: 'pointer',
        }}>
        <Typography variant="h5">Filters</Typography>
      </Box>
      <Divider />
      <Stack gap={2} py={2}>
        {hasList(wofStatuses) && (
          <MuiFormSelect
            id="wofStatus"
            label="WoF Status"
            options={wofStatuses}
            value={filtered.wofStatus}
            onChange={onSelect('wofStatus')}
            includeEmptyOption />
        )}
        {hasList(registrationStatuses) && (
          <MuiFormSelect
            id="registrationStatus"
            label="Registration Status"
            options={registrationStatuses}
            value={filtered.registrationStatus}
            onChange={onSelect('registrationStatus')}
            includeEmptyOption />
        )}
        {hasList(agreementTypes) && (
          <MuiFormSelect
            id="agreementType"
            label="Agreement Type"
            options={agreementTypes}
            value={filtered.agreementType}
            onChange={onSelect('agreementType')}
            includeEmptyOption />
        )}
        {hasList(fmoTypes) && (
          <MuiFormSelect
            id="fmoType"
            label="FMO"
            options={fmoTypes}
            value={filtered.fmoType}
            onChange={onSelect('fmoType')}
            includeEmptyOption />
        )}
      </Stack>
    </Box>
  )
}

FilterAttributes.propTypes = {
  filters: PropTypes.object.isRequired,
  filtered: PropTypes.object.isRequired,
  onFilter: PropTypes.func.isRequired,
}

export default FilterAttributes
